import useTranslation from '../../hooks/useTranslation';
import {useSelector} from 'react-redux';
import timeFormAPI from '../../api/ui/timeFormAPI';
import {useEffect, useState} from 'react';
import {create} from './table-schema';
import changeNumApi from '../../api/ui/changeNumApi';
import logDataAPI from '../../constants/logDataAPI';
import {getTokenTypeName} from '../../constants/base';

function useSchemaRentalLog() {
    const {t} = useTranslation();
    const locale = useSelector((state) => state.language.locale);

    /**
     * 테이블 헤더에 표시할 항목 문자열 배열
     */
    const headerKeys = [
        'admin.log.perplay.rental.table.head.no', // "렌탈 번호",
        'admin.log.perplay.rental.table.head.user', // "유저 이메일 (ID)",
        'admin.log.perplay.rental.table.head.tran', // "트랜잭션 번호",
        'admin.log.perplay.rental.table.head.nft', // "NFT UID",
        'admin.log.perplay.rental.table.head.type', // "렌탈 유형",
        'admin.log.perplay.rental.table.head.cost', // "렌탈 비용",
        'admin.log.perplay.rental.table.head.start', // "렌탈 시작 시각",
        'admin.log.perplay.rental.table.head.end', // "렌탈 만료 시각",
    ];

    const getCost = (row) => {
        if (row?.tokenType === 100) {
            return row?.cost;
        }
        const cost = changeNumApi.div18(row?.cost);
        const token = getTokenTypeName(row?.tokenType);
        return `${cost} ${token}`;
    };

    /**
     * 서버로부터 전달받은 request를 테이블에 표시할 내용으로 변환한다.
     *
     * 오브젝트 키는 param1, param10 등의 형식으로 param 다음에 숫자를 붙여서 사용한다.
     *
     * param1은 헤더의 첫번째 표시되는 항목이다.
     *
     * 헤더에는 표시되지 않지만 상세에 표시될 항목의 경우 headSize 이후의 숫자를 사용한다.
     *
     * key는 반드시 있어야 한다.
     * @param {object} row
     * @returns
     */
    const parse = (row) => {
        const no = row?.rentalNo || 0;
        const email = row?.email || '';
        const account = row?.accountNo || '';
        const tran = row?.rentalTransactionNo || 0;
        const nft = row?.nftUid || '';
        const type = logDataAPI.nftRentalType(row.rentalType);
        const cost = getCost(row);
        const startAt = timeFormAPI.changeDataLog(row?.rentalStartAt);
        const endAt = timeFormAPI.changeDataLog(row?.rentalEndAt);

        return {
            key: no,
            param1: no,
            param2: `${email} (${account})`,
            param3: tran,
            param4: nft,
            param5: type,
            param6: cost,
            param7: startAt,
            param8: endAt,
        };
    };

    /**
     * 로그 데이터를 클릭했을 때 보여줄 디테일 다이얼로그에 보여줄 항목을 작성한다.
     *
     * 입력값인 row는 위의 parse에서 변환된 값이다.
     *
     * @param {object} row
     * @returns
     */
    const details = (row) => {
        const array = [];
        if (row) {
            //
        }
        return array;
    };

    const [schema, setSchema] = useState();

    useEffect(() => {
        const headers = headerKeys.map((key) => t(key));
        const schema = create({
            heads: headers,
            parseFunc: parse,
            detailFunc: details,
        });
        setSchema(schema);
    }, [locale]);

    return {schema: schema};
}

export default useSchemaRentalLog;
